module.exports = __webpack_public_path__ + "static/assets/73e22aea307f17d2e290066384eae0e4.png";